import { render, staticRenderFns } from "./LiquorLife.vue?vue&type=template&id=b7fea54c&scoped=true&"
import script from "./LiquorLife.vue?vue&type=script&lang=js&"
export * from "./LiquorLife.vue?vue&type=script&lang=js&"
import style0 from "./LiquorLife.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./LiquorLife.vue?vue&type=style&index=1&id=b7fea54c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7fea54c",
  null
  
)

export default component.exports